<router-outlet></router-outlet>

<span style="color:#4370D9"></span>
